import React from 'react'
import { Row, Col, Button } from 'reactstrap'
import { connect, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import ReactSelect from 'react-select'
import useFetchingAgreement from './useFetchingAgreement'
import { agreementSelected } from '../actions/companyActionCreators'
import LoadingSpinner from '../Shared/LoadingSpinner'
import HeaderRow from '../Shared/LayoutComponents/HeaderRow'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import PageHeading from '../Shared/LayoutComponents/PageHeading'

const SelectAgreement = (props) => {
  useFetchingAgreement({ company: props.createSelected })
  const dispatch = useDispatch()

  if (props.loading) {
    return <LoadingSpinner />
  } else {
    return (
      <PageContainer>
        <Row>
          <Col md={3}></Col>
          <Col md={6}>
            <HeaderRow center>
              <PageHeading>2. Select Agreement to Sync </PageHeading>
            </HeaderRow>
            <HeaderRow center small>
              <h5>{props.createSelected.label}</h5>
            </HeaderRow>
            <HeaderRow center>
              <div style={{ width: '100%' }}>
                <ReactSelect
                  value={props.selectedAgreement}
                  onChange={(property, value) => dispatch(agreementSelected(property))}
                  isClearable
                  isSearchable
                  options={props.companyAgreementList}
                />
              </div>
            </HeaderRow>
            <HeaderRow between>
              <div>
                <Link to="/Create">
                  <Button outline color="secondary">
                    Back
                  </Button>
                </Link>{' '}
              </div>
              <div>
                <Link disabled={props.selectedAgreement ? false : true} to="/Create/Details">
                  <Button className="float-right" color="primary" disabled={props.selectedAgreement ? false : true}>
                    Next
                  </Button>
                </Link>
              </div>
            </HeaderRow>
          </Col>
          <Col md={3}></Col>
        </Row>
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.company.loading,
  createSelected: state.company.createSelected,
  selectedAgreement: state.company.selectedAgreement,
  companyAgreementList: state.company.companyAgreementList,
})

const mapDispatchToProps = {
  agreementSelected,
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectAgreement)
